import { ApiResponse, AppInfo } from '@types';
import axios from 'axios';

export const getAppInfoRequest = (): Promise<ApiResponse<AppInfo>> => {
    return axios.get('/api/info');
};
